import * as React from 'react';
import { registerIcons, unregisterIcons } from '@fluentui/style-utilities';

const iconAssets: { [name: string]: string } = {
  accdb: require('./assets/file-type-icons/accdb.svg'),
  archive: require('./assets/file-type-icons/archive.svg'),
  audio: require('./assets/file-type-icons/audio.svg'),
  companyfolder: require('./assets/file-type-icons/companyfolder.svg'),
  csv: require('./assets/file-type-icons/csv.svg'),
  desktopfolder: require('./assets/file-type-icons/desktopfolder.svg'),
  docset: require('./assets/file-type-icons/docset.svg'),
  docx: require('./assets/file-type-icons/docx.svg'),
  documentsfolder: require('./assets/file-type-icons/documentsfolder.svg'),
  dotx: require('./assets/file-type-icons/dotx.svg'),
  favoritesfolder: require('./assets/file-type-icons/favoritesfolder.svg'),
  folder: require('./assets/file-type-icons/folder.svg'),
  genericfile: require('./assets/file-type-icons/genericfile.svg'),
  linkedfolder: require('./assets/file-type-icons/linkedfolder.svg'),
  mpp: require('./assets/file-type-icons/mpp.svg'),
  mpt: require('./assets/file-type-icons/mpt.svg'),
  officescript: require('./assets/file-type-icons/officescript.svg'),
  one: require('./assets/file-type-icons/one.svg'),
  onepage: require('./assets/file-type-icons/onepage.svg'),
  onetoc: require('./assets/file-type-icons/onetoc.svg'),
  pdf: require('./assets/file-type-icons/pdf.svg'),
  photo: require('./assets/file-type-icons/photo.svg'),
  picturesfolder: require('./assets/file-type-icons/picturesfolder.svg'),
  potx: require('./assets/file-type-icons/potx.svg'),
  ppsx: require('./assets/file-type-icons/ppsx.svg'),
  pptx: require('./assets/file-type-icons/pptx.svg'),
  presentation: require('./assets/file-type-icons/presentation.svg'),
  pub: require('./assets/file-type-icons/pub.svg'),
  rtf: require('./assets/file-type-icons/rtf.svg'),
  sharedfolder: require('./assets/file-type-icons/sharedfolder.svg'),
  spreadsheet: require('./assets/file-type-icons/spreadsheet.svg'),
  txt: require('./assets/file-type-icons/txt.svg'),
  vector: require('./assets/file-type-icons/vector.svg'),
  video: require('./assets/file-type-icons/video.svg'),
  vsdx: require('./assets/file-type-icons/vsdx.svg'),
  vssx: require('./assets/file-type-icons/vssx.svg'),
  vstx: require('./assets/file-type-icons/vstx.svg'),
  xlsx: require('./assets/file-type-icons/xlsx.svg'),
  xltx: require('./assets/file-type-icons/xltx.svg'),
  xsn: require('./assets/file-type-icons/xsn.svg'),
  zip: require('./assets/file-type-icons/zip.svg'),
};

const iconSizes = [16, 20, 24, 32, 40, 48, 64, 96];

export function withLocalFileTypeIconFallback(iconProps: any) {
  const iconName = iconProps && iconProps.iconName;
  const suffixMatch =
    typeof iconName === 'string'
      ? iconName.match(
          /(16|20|24|32|40|48|64|96)(?:(_(?:1\.5|2|3|4)x))?_(svg|png)$/
        )
      : null;
  const iconType = suffixMatch
    ? iconName.slice(0, iconName.length - suffixMatch[0].length)
    : '';
  const hasLocalIcon = Object.prototype.hasOwnProperty.call(
    iconAssets,
    iconType
  );

  if (hasLocalIcon) {
    return iconProps;
  }

  const suffix = suffixMatch
    ? `${suffixMatch[1]}${suffixMatch[2] || ''}_${suffixMatch[3]}`
    : '16_svg';

  return Object.assign({}, iconProps, {
    iconName: `genericfile${suffix}`,
  });
}

export function registerLocalFileTypeIcons() {
  iconSizes.forEach(size => {
    const icons: { [name: string]: React.ReactElement<any> } = {};

    Object.keys(iconAssets).forEach(type => {
      const image = React.createElement('img', {
        src: iconAssets[type],
        alt: '',
        width: '100%',
        height: '100%',
      });

      // Point every SVG/PNG density alias at the same local scalable artwork.
      icons[`${type}${size}_svg`] = image;
      icons[`${type}${size}_1.5x_svg`] = image;
      icons[`${type}${size}_png`] = image;
      icons[`${type}${size}_1.5x_png`] = image;
      icons[`${type}${size}_2x_png`] = image;
      icons[`${type}${size}_3x_png`] = image;
      icons[`${type}${size}_4x_png`] = image;
    });

    const iconNames = Object.keys(icons);
    unregisterIcons(iconNames);
    registerIcons(
      {
        fontFace: {},
        style: { width: size, height: size, overflow: 'hidden' },
        icons,
        mergeImageProps: true,
      },
      { disableWarnings: true }
    );
  });
}
